// components/TextAreaComponent.jsx
import React from 'react';
import styleform from '../styles/form.module.scss';

const TextAreaComponent = (props) => {
  const { 
    value, 
    onChange, 
    styleGroup, 
    label, 
    name, 
    id, 
    htmlFor, 
    styleLabel, 
    placeholder, 
    disabled,
    rows = 3, // ✅ Altura por defecto
    cols,
    maxLength,
  } = props;

  return (
    <div className={`${styleform.input_fuera} ${styleGroup}`}>
      {label ? (
        <label htmlFor={htmlFor} className={`${styleLabel}`}>
          {label}
        </label>
      ) : null}
      <textarea
        id={id}
        name={name}
        className="form-control"
        placeholder={placeholder}
        value={value}
        onChange={onChange}
        disabled={disabled}
        rows={rows}
        cols={cols}
        maxLength={maxLength}
      />
    </div>
  );
};

export default TextAreaComponent;